import React, { useContext, useState } from "react";
import { Box, Typography, Chip, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../ProgressBar/ProgressBar";
import { AuthContext } from "../Context/AuthContext";
import AuthPromptDialog from "../AuthPromptDialog/AuthPromptDialog";
import { getDocCompletedPercent } from "../../utils/progress";

const CompletedDocumentCard = ({ doc }) => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [authOpen, setAuthOpen] = useState(false);

  const percent = getDocCompletedPercent(doc);
  const thumb = doc?.pages?.[0]?.imageUrl;

  if (percent !== 100) return null;

  const handleViewDocument = () => {
    const target = `/transcription/documents/${doc.documentId}`;

    if (!user) {
      setAuthOpen(true);
      return;
    }
    navigate(target);
  };

  return (
    <>
      <Box
        sx={{
          width: "400px",
          padding: "20px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {thumb && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              component="img"
              src={thumb}
              alt={doc.title}
              sx={{
                width: "200px",
                height: "300px",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
          </Box>
        )}

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }} noWrap>
            {doc.title}
          </Typography>
          <Chip size="small" label="Completed" color="success" />
        </Box>

        <ProgressBar documents={[doc]} />

        {doc.completedAt && (
          <Typography variant="body2">
            Completed: {new Date(doc.completedAt).toDateString()}
          </Typography>
        )}

        <Button
          variant="contained"
          sx={{
            mt: 1,
            textTransform: "none",
            fontWeight: 500,
            borderRadius: "8px",
          }}
          onClick={handleViewDocument}
        >
          View Document
        </Button>
      </Box>

      <AuthPromptDialog
        open={authOpen}
        onClose={() => setAuthOpen(false)}
        title="Login required"
        message="You're trying to access the Transcription Tool. Please login or create an account to begin volunteering."
      />
    </>
  );
};

export default CompletedDocumentCard;
